module.exports = __webpack_public_path__ + "static/03a-aec42816d7399231873824c4dcc24b07.jpg";